var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.714 2.28594C9.11048 -0.317622 4.88952 -0.317622 2.28595 2.28594C-0.317612 4.88951 -0.317612 9.11047 2.28595 11.714C4.88952 14.3176 9.11048 14.3176 11.714 11.714C14.3176 9.11047 14.3176 4.88951 11.714 2.28594ZM8.41421 9.35701L7 7.9428L5.58579 9.35701C5.32557 9.61723 4.90319 9.61723 4.64298 9.35701C4.38276 9.0968 4.38276 8.67442 4.64298 8.4142L6.05719 6.99999L4.64298 5.58578C4.38276 5.32556 4.38276 4.90318 4.64298 4.64297C4.90319 4.38275 5.32557 4.38275 5.58579 4.64297L7 6.05718L8.41421 4.64297C8.67443 4.38275 9.09681 4.38275 9.35702 4.64297C9.61724 4.90318 9.61724 5.32556 9.35702 5.58578L7.94281 6.99999L9.35702 8.4142C9.61724 8.67442 9.61724 9.0968 9.35702 9.35701C9.09681 9.61723 8.67443 9.61723 8.41421 9.35701Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusOutlined);
export default __webpack_public_path__ + "static/media/plus-outlined.7bf4048c5e1fba618efd83c33e802506.svg";
export { ForwardRef as ReactComponent };